var _g, _rect, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNewPatient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_242_20122)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 30,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_242_20122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_242_20122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9993 41.3333V37.8333H42.4993V35.5H45.9993V32H48.3327V35.5H51.8327V37.8333H48.3327V41.3333H45.9993ZM35.4993 39C34.216 39 33.1174 38.543 32.2035 37.6291C31.2896 36.7152 30.8327 35.6166 30.8327 34.3333C30.8327 33.05 31.2896 31.9513 32.2035 31.0375C33.1174 30.1236 34.216 29.6666 35.4993 29.6666C36.7827 29.6666 37.8813 30.1236 38.7952 31.0375C39.7091 31.9513 40.166 33.05 40.166 34.3333C40.166 35.6166 39.7091 36.7152 38.7952 37.6291C37.8813 38.543 36.7827 39 35.4993 39ZM26.166 48.3333V45.0666C26.166 44.4055 26.3363 43.7977 26.677 43.2431C27.0169 42.6893 27.4688 42.2666 28.0327 41.975C29.2382 41.3722 30.4632 40.9199 31.7077 40.6181C32.9521 40.3171 34.216 40.1666 35.4993 40.1666C36.7827 40.1666 38.0466 40.3171 39.291 40.6181C40.5355 40.9199 41.7605 41.3722 42.966 41.975C43.5299 42.2666 43.9818 42.6893 44.3217 43.2431C44.6623 43.7977 44.8327 44.4055 44.8327 45.0666V48.3333H26.166Z",
    fill: "#04B7B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_242_20122",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.380392 0 0 0 0 0.380392 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_242_20122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_242_20122",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewPatient);
export default __webpack_public_path__ + "static/media/AddNewPatient.1ecea4cc45a83fe59abf5bd7769751f6.svg";
export { ForwardRef as ReactComponent };